import { Pipe, PipeTransform } from '@angular/core';
import { ConstructionProjectFeatureKey } from '@construction/construction.enums';

const FEATURE_NAME_MAP: Record<ConstructionProjectFeatureKey, string> = {
  [ConstructionProjectFeatureKey.DRONE_IMAGERY]: 'Drone Imagery',
  [ConstructionProjectFeatureKey.LOGISTICS_INVENTORY]: 'Logistics & Inventory',
  [ConstructionProjectFeatureKey.QC_ISSUES]: 'QC Observations',
  [ConstructionProjectFeatureKey.DIGITAL_TWIN]: 'Progress Tracking',
  [ConstructionProjectFeatureKey.PRODUCTION_TRACKING]: 'Production Tracking',
  [ConstructionProjectFeatureKey.EQUIPMENT_TRACKING]: 'Equipment Tracking',
  [ConstructionProjectFeatureKey.APPROVALS]: 'Approvals',
  [ConstructionProjectFeatureKey.OMEGA]: 'Activity Tracking',
  [ConstructionProjectFeatureKey.MV_CIRCUIT]: 'Commissioning',
  [ConstructionProjectFeatureKey.ADVANCED_DETECTION]: 'Element Detection',
  [ConstructionProjectFeatureKey.TERAFAB]: 'Terafab',
  [ConstructionProjectFeatureKey.DOCUMENTS]: 'Documents',
};

@Pipe({
  name: 'featureNamePipe',
})
export class FeatureNamePipePipe implements PipeTransform {
  public transform(featureKey: ConstructionProjectFeatureKey): string {
    return FEATURE_NAME_MAP[featureKey] ?? featureKey;
  }
}
